module.exports = __webpack_public_path__ + "static/media/can-peek-big-opt.693b3a54.gif";